import ImageGallery from "components/ImageGallery";
import * as React from 'react';
export default {
  ImageGallery,
  React
};